// extracted by mini-css-extract-plugin
export default {"logoWrapper":"pzoneLogo_logoWrapper__pgHQT","logoWidth":"pzoneLogo_logoWidth__-xPHN"};